import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { EntitlementsProvider } from './context/EntitlementsContext';
import { PreferencesProvider } from './context/PreferencesContext';
import { ScreeningProvider } from './context/ScreeningContext';

const isVersionBRuntime = (): boolean => {
  const variant = String(process.env.REACT_APP_APP_VARIANT || 'A').toUpperCase();
  const pathname = window.location.pathname || '';
  return variant === 'B' || pathname === '/version-b' || pathname.startsWith('/version-b/');
};

const isExternalWalletError = (value: unknown): boolean => {
  const text = value instanceof Error
    ? `${value.message}\n${value.stack || ''}`
    : String(value || '');
  return text.includes('Failed to connect to MetaMask') || text.includes('chrome-extension://');
};

if (isVersionBRuntime()) {
  const previousOnError = window.onerror;
  window.onerror = (message, source, lineno, colno, error) => {
    if (
      isExternalWalletError(error) ||
      isExternalWalletError(message) ||
      isExternalWalletError(source)
    ) {
      return true;
    }
    if (typeof previousOnError === 'function') {
      return previousOnError(message, source, lineno, colno, error);
    }
    return false;
  };

  window.addEventListener('error', (event) => {
    if (
      isExternalWalletError(event.error) ||
      isExternalWalletError(event.message) ||
      isExternalWalletError(event.filename)
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  window.addEventListener('unhandledrejection', (event) => {
    if (isExternalWalletError(event.reason)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <EntitlementsProvider>
        <PreferencesProvider>
          <ScreeningProvider>
            <App />
          </ScreeningProvider>
        </PreferencesProvider>
      </EntitlementsProvider>
    </AuthProvider>
  </React.StrictMode>
);
